import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InvalidControlScrollDirective } from 'src/shared/share-directives/directives/invalid-control-scroll.directive';
import { ConfirmDialogDirective } from './directives/confirm-dialog.directive';
import { ConfirmRequestDialogDirective } from './directives/confirm-request-dialog.directive';
import { OutOfFocusDirective } from './directives/out-of-focus.directive';


@NgModule({
  declarations: [
    InvalidControlScrollDirective,
    ConfirmDialogDirective,
    ConfirmRequestDialogDirective,
    OutOfFocusDirective,
  ],
  exports: [
    InvalidControlScrollDirective,
    ConfirmDialogDirective,
    ConfirmRequestDialogDirective,
    OutOfFocusDirective,
  ],
  imports: [
    CommonModule,
  ],
})
export class ShareDirectivesModule {
}
